// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.streams-drawer-recommended-header cu-icon[name="instagram"] .cu-icon {
  height: 24px;
  width: 24px;
}
.streams-drawer-recommended-header .cu-icon-sm {
  height: 16px;
  width: 16px;
}
.stream-description-wrapper {
  height: 24px;
}
`, "",{"version":3,"sources":["webpack://./app/streams-drawer/streams-drawer-recommended-header/streams-drawer-recommended-header.less"],"names":[],"mappings":"AAKA;EAGI,YAAA;EACA,WAAA;AANJ;AAEA;EAQI,YAAA;EACA,WAAA;AAPJ;AAWA;EACE,YAAA;AATF","sourcesContent":["//\n// Copyright (c) 2011-2018 by Curalate, Inc.\n//\n@import (reference) '../../../css/unison';\n\n.streams-drawer-recommended-header {\n  \n  cu-icon[name=\"instagram\"] .cu-icon {\n    height: @cu-spacing-4;\n    width: @cu-spacing-4;\n  }\n\n  .cu-icon-sm {\n    height: @cu-spacing-3;\n    width: @cu-spacing-3;\n  }\n}\n\n.stream-description-wrapper {\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
